import { Component, input, signal, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { ChartComponent, NgApexchartsModule } from 'ng-apexcharts';
import { ChartOptions } from './types';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'shared-charts',
  templateUrl: './base.component.html',
  styleUrl: './base.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgApexchartsModule],
})
export class BaseChartComponent {
  private readonly chartElement = viewChild(ChartComponent);
  protected readonly imgURI = signal('');
  readonly schema = input.required<ChartOptions>();

  protected async chartReady() {
    const data = await this.chartElement()?.dataURI();
    if (data && 'imgURI' in data) {
      this.imgURI.set(data.imgURI);
    }
  }
}
